import _ from 'lodash';
import { womanProductState } from '../reducers/checkCoverageReducer';

export const getWomanProductState = (state: {}): womanProductState => {
  return _.get(state, `hk-emma-web-core/womanProduct`, {});
};

export const getCheckCoverageService = (state: {}): object => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-check-coverage`,
    {},
  );
};

export const getCardViewConfig = (state: {}, moduleName: string) => {
  return _.get(state, `hk-emma-web-core/app.moduleConfig.${moduleName}`, {});
};

export const getPolicyCoverageApi = (state: {}): object => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-check-coverage.coverageApi`,
    {},
  );
};

export const getHospitalsApi = (state: {}): object => {
  return _.get(
    state,
    `hk-emma-web-core/app.moduleConfig.emma-check-coverage.getHospitalsApi`,
    {},
  );
};
